<template>
  <MapModal
    :modalNode="modalNode"
    :title="title"
    :id="ModelNase.id"
    :close="shutDown"
    class="MapModal"
  >
    <template slot="head">
      <div class="icons">
        <i
          class="el-icon-video-play"
          v-show="!state && startBtnShow"
          @click="playFun"
          style="color: rgba(255, 255, 255, 0.9);"
        ></i>
        <i
          class="el-icon-video-pause"
          style="color: rgba(255, 255, 255, 0.9);"
          v-show="state"
          @click="suspended"
        ></i>

        <i
          class="el-icon-refresh-right"
          @click="reset"
          style="color: rgba(255, 255, 255, 0.9);"
        ></i>
      </div>
    </template>
    <template slot="content">
      <div
        class="content"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
      >
        <div
          id="visualization"
          :class="{
            isOperate: !isOperate,
          }"
        ></div>
      </div>
    </template>
  </MapModal>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
export default {
  components: {
    MapModal,
  },
  props: {
    // 时间初始值
    initCustomDate: {
      type: String,
    },
    // 最大时间
    maxTime: {
      type: String,
    },
    // y轴数据
    groups: {
      type: Array,
      default: function() {
        return [];
      },
    },
    // x轴数据
    items: {
      type: Array,
      default: function() {
        return [];
      },
    },
    // 标题
    title: {
      type: String,
      default: function() {
        return "方案模拟";
      },
    },
    // 当前状态
    operationState: {
      type: String,
      default: function() {
        return "play";
      },
    },
    // 每秒前进单位
    doubleSpeed: {
      type: String || Number,
      default: function() {
        return "day";
      },
    },
    // 播放按钮
    startBtnShow: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    containerWidth: {
      type: String,
      default: function() {
        return "100%";
      },
    },
    containerLeft: {
      type: String,
      default: function() {
        return 0;
      },
    },
    loading: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    returnTime: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
    isOperate: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  data() {
    return {
      ModelNase: {
        // title: "方案模拟",
        id: "programmeSimulation",
      },
      modalNode: {
        ModelNase: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            y: 0,
            left: "0",
            bottom: "3", //慎用 会导致拖动问题
            top: "auto",
            // top:20
            unit: "%", // 默认px
          },
          width: "100%",
          // auto 自适应
          height: "225px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      timeline: null,
      state: false,
      customDate: "2022-04-12 00:00:00",
      timer: null,
      itemsdateList: [],
      firstFunNum: 0,
      itemsIndex: [],
      focusArr: [],
      doubleSpeedType: {
        second: (1 / 1000) * 20, // 一秒
        minute: (60 / 1000) * 20, // 一分钟
        hour: (3600 / 1000) * 20, // 一小时
        day: (86400 / 1000) * 20, // 一天
        week: ((86400 * 7) / 1000) * 20,
        month: (2592000 / 1000) * 20, // 三十天
      },
      locationShow: false,
    };
  },
  watch: {},
  methods: {
    shutDown() {
      console.log("老方法 触发关闭");
      this.$emit("shutDown");
    },
    getData() {
      console.log(this.initCustomDate, "initCustomDate");
      this.customDate = this.initCustomDate;
      setTimeout(() => {
        // this.$GLOBAL.map.setCameraView({
        //   lng: testData[0][0][0],
        //   lat: testData[0][0][1],
        //   alt: testData[0][0][2],
        // });
        var container = document.getElementById("visualization");
        var groups = new vis.DataSet(this.groups);
        var items = new vis.DataSet(this.items);
        console.log(this.maxTime);
        // 时间轴配置项
        var options = {
          // locales: {
          //   mylocale: {
          //     current: "current",
          //     time: "time",
          //   },
          // },
          // timeAxis: { scale: "millisecond", step: 5 },
          start: this.customDate,
          min: this.customDate,
          max: this.maxTime,
          height: "210px",
          editable: {
            add: false, // 通过双击添加新项目
            updateTime: true, // 水平拖动项目
            updateGroup: false, // 将项目从一个组拖到另一个组
            remove: false, // 点击右上方的删除按钮删除项目
            overrideItems: false, // 允许这些选项覆盖item.editable
          },
          // editable: false,
          showCurrentTime: false, //显示当前日期
          orientation: "top", //时间轴项目的方向：“顶部”或“底部”（默认）。
          locale: moment.locale("zh-cn"),
          groupOrder: function(a, b) {
            //按字段名称或自定义排序函数对组进行排序
            // return a.value - b.value;
          },
        };
        console.log(container, items, groups, options);
        this.timeline = new vis.Timeline(container, items, groups, options);
        this.itemsdateList = [];
        console.log(this.items);
        this.items.forEach((el, i) => {
          this.itemsdateList.push({
            start: el.start,
            end: el.end,
            index: i,
          });
        });
        setTimeout(() => {
          this.timeline.addCustomTime(this.customDate, "customDate");
          console.log(this.timeline);
          this.timeline.focus(this.items[0].id);
          setTimeout(() => {
            this.locationShow = true;
          }, 900);

          this.timeline.on("timechanged", (properties) => {
            if (
              moment(properties.time).format("YYYY-MM-DD HH:mm:ss") <
              this.initCustomDate
            ) {
              this.timeline.setCustomTime(this.initCustomDate, "customDate");
              this.customDate = this.initCustomDate;
            } else {
              this.customDate = moment(properties.time).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              var body = document.getElementsByClassName("vis-custom-time")[0];
            }

            if (
              moment(properties.time).format("YYYY-MM-DD HH:mm:ss") >
              this.maxTime
            ) {
              this.timeline.setCustomTime(this.maxTime, "customDate");
              this.customDate = this.maxTime;
            }
            this.calculationDate();
          });
          this.timeline.on("timechange", (properties) => {
            //拖动时间轴方法
            this.removeTimer();
            this.$emit("removeTimer");
          });

          this.timeline.on("mouseUp", (res) => {
            //拖动完成松开鼠标事件
            console.log("松开");
            console.log(res);
            if (this.state) {
              this.state = false;
            }
            this.$emit("mouseUp", this.getFullTime(res.time.valueOf()));
          });
        }, 50);
      }, 500);
    },
    playFun() {
      this.state = !this.state;
      this.timerFun();
    },
    // 求数组是否相等
    arrayEquals(arr1, arr2) {
      var flay =
        arr1.length === arr2.length && arr1.filter((t) => !arr2.includes(t));
      return flay;
    },

    timerFun() {
      clearInterval(this.timer);
      this.timer = null;
      this.focusArr = [];
      this.timer = setInterval(() => {
        this.customDate = this.dateAdd(
          this.customDate,
          this.doubleSpeedType[this.doubleSpeed]
        );

        if (this.returnTime) {
          this.$emit("returnTimeFun", this.customDate);
        }
        this.timeline.setCustomTime(this.customDate, "customDate");
        this.calculationDate();
        if (
          new Date(this.customDate).getTime() >=
          new Date(this.maxTime).getTime()
        ) {
          this.$emit("endTimeFun", this.customDate);
          this.suspended();
        }
      }, 20);
      this.$emit("beginFun");
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.timer);
        this.timer = null;
      });
    },
    suspended() {
      //暂停
      this.state = !this.state;
      this.removeTimer();
      this.$emit("suspended");
    },
    reset() {
      this.removeTimer();
      this.state = false;
      this.customDate = this.initCustomDate;

      this.items.forEach((el) => {
        el.className = "";
      });
      this.items[0].className = "complete-time-orange";
      this.timeline.setItems(this.items);
      // this.itemsIndex = 0;
      this.timeline.setCustomTime(this.customDate, "customDate");
      this.timeline.focus(this.items[0].id);

      this.$emit("resetTime");
    },
    removeTimer() {
      clearInterval(this.timer);
      this.timer = null;

      // clearInterval(this.timer2);
      // this.timer2 = null;
    },
    calculationDate() {
      let arr = [],
        indexArr = [],
        arrs = [];
      this.items.forEach((data, index) => {
        let startItems = new Date(data.start.replace(/-/g, "/")).getTime(),
          endItems = data.end
            ? new Date(data.end.replace(/-/g, "/")).getTime()
            : new Date(data.start.replace(/-/g, "/")).getTime(),
          customDate = new Date(this.customDate.replace(/-/g, "/")).getTime();

        if (customDate >= startItems && customDate <= endItems) {
          if (data.Level) {
          }
          arr.push(data.id);
          indexArr.push(index);
          arrs.push(data);
        }
      });
      if (
        this.arrayEquals(this.focusArr, arr) === false ||
        this.arrayEquals(this.focusArr, arr).length > 0
      ) {
        // console.log("当前移除数据", viewShed.difference(this.focusArr, arr));
        // console.log("当前添加数据", viewShed.difference(arr, this.focusArr));
        console.log("当前数据", this.items);
        // 事件
        this.$emit("animationNodes", {
          remove: viewShed.difference(this.focusArr, arr),
          add: viewShed.difference(arr, this.focusArr),
          item: arr,
          arrs: arrs,
          customDate: this.customDate,
          items: this.items,
        });
        this.focusArr = arr;
        this.itemsIndex = indexArr;
        this.items.forEach((el) => {
          el.className = "";
        });
        this.itemsIndex.forEach((data) => {
          this.items[data].className = "complete-time-orange";
        });
        this.timeline.setItems(this.items);
        this.timeline.focus(this.focusArr);
      }
    },
    dateAdd(d, num) {
      var d = new Date(
        d.substring(0, 4),
        d.substring(5, 7) - 1,
        d.substring(8, 10),
        d.substring(11, 13),
        d.substring(14, 16),
        d.substring(17, 19),
        d.substring(20) == "" ? 0 : d.substring(20)
      );
      //毫秒数
      d.setTime(d.getTime() + num * 1000);
      return (
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth() + 1) +
        "-" +
        this.checkTime(d.getDate()) +
        " " +
        this.checkTime(d.getHours()) +
        ":" +
        this.checkTime(d.getMinutes()) +
        ":" +
        this.checkTime(d.getSeconds()) +
        ":" +
        this.checkTime(d.getMilliseconds())
      );
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    getFullTime(timestamp) {
      // 将时间戳转换为yy-mm-dd hh:mm:ss格式的方法
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return Y + M + D + h + m + s;
    },
    // readFile(index) {
    //   if (testData[index]) {
    //     programmeSimulation.startDrawGraphic(index, testData);
    //   }
    // },
  },
  mounted() {
    this.getData();
    this.$eventBus.$on("shutDownTime", (res) => {
      this.modalNode.ModelNase.head.fold.state = false;
    });
  },
  created() {
    this.modalNode.ModelNase.width = this.containerWidth;
    this.modalNode.ModelNase.offset.y = this.containerLeft;
    this.locationShow = false;
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 5px 15px 0 15px;
  position: relative;
}
#visualization {
  position: relative;
  width: 100%;
  // height: 170px;
}
.biaoqian {
  position: absolute;
  left: 137px;
  top: 8px;
  width: 22px;
  height: 30px;
  z-index: 1000;
  color: #6e94ff;

  i {
    position: absolute;
    left: 0;
    top: 0;
    cursor: default !important;
  }
}
/deep/.table {
  // background: #fff !important;
  z-index: 20000;
}
.MapModal /deep/ .table h3 {
  // color: #000 !important;
  border-bottom-color: rgba(0, 0, 0, 0) !important;
}
.icons {
  font-size: 24px;
  display: inline-block;
  position: absolute;
  left: 80px;
  top: -4px;
  z-index: 1000;
  i {
    margin-right: 15px;
    cursor: pointer;
  }
}
/deep/.plan-time-green {
  background-color: greenyellow;
  border-color: green;
}
/deep/.complete-time-orange {
  background-color: gold;
  border-color: orange;
}
/deep/ .table h3.modal-title div i {
  // color: #000 !important;
}
// /deep/.vis-custom-time {
//   left: 606px !important;
// }
/deep/ .el-scrollbar__wrap {
  margin-top: 0 !important;
  height: 215px !important;
}
/deep/.vis-item .vis-item-content {
  padding: 0 0 0 5px !important;
  text-align: center;
}
/deep/.vis-foreground {
  height: 45px !important;
}
/deep/.vis-text {
  height: 22px !important;
}
/deep/.vis-labelset .vis-label {
  // text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255, 255, 255, 0.9);
}
/deep/.vis-time-axis .vis-text {
  color: rgba(255, 255, 255, 0.9);
}
/deep/ .table h3.modal-title {
  padding-top: 4px;
}
/deep/.vis-custom-time {
  width: 6px;
  box-shadow: 0px 10px 15px #000;
}
/deep/.vis-time-axis .vis-grid.vis-major {
  border-color: #6a6a6a;
}
/deep/.vis-time-axis .vis-grid.vis-minor {
  border-color: #6a6a6a;
}
/deep/.vis-foreground .vis-group {
  border-color: #6a6a6a;
}
/deep/.vis-panel.vis-left {
  border-color: #6a6a6a;
}
/deep/.vis-labelset .vis-label {
  border-color: #6a6a6a;
}
/deep/.vis-panel.vis-top {
  border-color: #6a6a6a;
}
/deep/.vis-timeline {
  border-color: #6a6a6a;
}
/deep/.vis-panel.vis-center {
  border-color: #6a6a6a;
}
.isOperate::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
</style>
